// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 599px) {
  .mail-compose-dialog {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .mail-compose-dialog {
    width: 70%;
  }
}
.mail-compose-dialog .mat-mdc-dialog-container {
  padding: 0;
}
.mail-compose-dialog .mat-mdc-dialog-container .compose-form .signature {
  margin-top: -14px;
  margin-bottom: 8px;
  margin-left: auto;
}
.mail-compose-dialog .mat-mdc-dialog-container .compose-form .mat-mdc-form-field {
  width: 100%;
}
.mail-compose-dialog .mat-mdc-dialog-container .compose-form .show-hide-extra-fields {
  text-align: right;
  cursor: pointer;
  font-size: 12px;
}
.mail-compose-dialog .mat-mdc-dialog-container .compose-form .attachment-list {
  font-size: 13px;
}
.mail-compose-dialog .mat-mdc-dialog-container .compose-form .attachment-list .attachment {
  border: 1px solid;
  border-radius: 20px;
  padding-left: 16px;
  margin-top: 8px;
}
.mail-compose-dialog .mat-mdc-dialog-container .compose-form .attachment-list .attachment .filename {
  font-weight: 600;
}
.mail-compose-dialog .mat-mdc-dialog-container .compose-form .attachment-list .attachment:last-child {
  margin-bottom: 0;
}
.mail-compose-dialog .dialog-content-wrapper {
  max-height: 85vh;
  display: flex;
  flex-direction: column;
}
.mail-compose-dialog .email-attachments {
  padding: 24px 0;
  border-top: 1px solid;
}
.mail-compose-dialog .email-attachments .title {
  margin-bottom: 16px;
  font-weight: 600;
}
.mail-compose-dialog .email-attachments .attachments .preview {
  width: 100px;
  margin: 0 16px 8px 0;
  border-radius: 4px;
}
.mail-compose-dialog .email-attachments .attachments .link {
  margin-bottom: 2px;
}
.mail-compose-dialog .email-attachments .attachments .size {
  font-size: 11px;
}

.loading-shade {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/@fuse/scss/partials/_breakpoints.scss","webpack://./src/app/directives/compose-email/compose-dialog/compose-dialog.component.scss"],"names":[],"mappings":"AAiCQ;EC/BR;IAEQ,WAAA;EADN;AACF;AD6BQ;EC/BR;IAMQ,UAAA;EAAN;AACF;AAEI;EACI,UAAA;AAAR;AAGY;EACI,iBAAA;EACA,kBAAA;EACA,iBAAA;AADhB;AAIY;EACI,WAAA;AAFhB;AAKY;EACI,iBAAA;EACA,eAAA;EACA,eAAA;AAHhB;AAMY;EACI,eAAA;AAJhB;AAMgB;EACI,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAJpB;AAMoB;EACI,gBAAA;AAJxB;AAOoB;EACI,gBAAA;AALxB;AAYI;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;AAVR;AAaI;EACI,eAAA;EACA,qBAAA;AAXR;AAaQ;EACI,mBAAA;EACA,gBAAA;AAXZ;AAeY;EACI,YAAA;EACA,oBAAA;EACA,kBAAA;AAbhB;AAgBY;EACI,kBAAA;AAdhB;AAiBY;EACI,eAAA;AAfhB;;AAqBA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAlBJ","sourcesContent":["// Media step breakpoint mixin based on Angular Material lib\n$breakpoints: (\n    xs: 'screen and (max-width: 599px)',\n    sm: 'screen and (min-width: 600px) and (max-width: 959px)',\n    md: 'screen and (min-width: 960px) and (max-width: 1279px)',\n    lg: 'screen and (min-width: 1280px) and (max-width: 1919px)',\n    xl: 'screen and (min-width: 1920px) and (max-width: 5000px)',\n    lt-sm: 'screen and (max-width: 599px)',\n    lt-md: 'screen and (max-width: 959px)',\n    lt-lg: 'screen and (max-width: 1279px)',\n    lt-xl: 'screen and (max-width: 1919px)',\n    gt-xs: 'screen and (min-width: 600px)',\n    gt-sm: 'screen and (min-width: 960px)',\n    gt-md: 'screen and (min-width: 1280px)',\n    gt-lg: 'screen and (min-width: 1920px)'\n) !default;\n\n// Re-map the breakpoints for the helper classes\n$helper-breakpoints: (\n    xs: null,\n    sm: 'gt-xs',\n    md: 'gt-sm',\n    lg: 'gt-md',\n    xl: 'gt-lg'\n);\n\n@mixin media-breakpoint($breakpointName) {\n\n    $mediaQuery: map-get($breakpoints, $breakpointName);\n\n    @if ($mediaQuery == null) {\n        @content\n    } @else {\n        @media #{$mediaQuery} {\n            @content\n        }\n    }\n}\n","@import \"src/@fuse/scss/partials/breakpoints\";\n\n.mail-compose-dialog {\n    @include media-breakpoint(\"xs\") {\n        width: 100%;\n    }\n\n    @include media-breakpoint(\"gt-xs\") {\n        width: 70%;\n    }\n\n    .mat-mdc-dialog-container {\n        padding: 0;\n\n        .compose-form {\n            .signature {\n                margin-top: -14px;\n                margin-bottom: 8px;\n                margin-left: auto;\n            }\n\n            .mat-mdc-form-field {\n                width: 100%;\n            }\n\n            .show-hide-extra-fields {\n                text-align: right;\n                cursor: pointer;\n                font-size: 12px;\n            }\n\n            .attachment-list {\n                font-size: 13px;\n\n                .attachment {\n                    border: 1px solid;\n                    border-radius: 20px;\n                    padding-left: 16px;\n                    margin-top: 8px;\n\n                    .filename {\n                        font-weight: 600;\n                    }\n\n                    &:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n            }\n        }\n    }\n\n    .dialog-content-wrapper {\n        max-height: 85vh;\n        display: flex;\n        flex-direction: column;\n    }\n\n    .email-attachments {\n        padding: 24px 0;\n        border-top: 1px solid;\n\n        .title {\n            margin-bottom: 16px;\n            font-weight: 600;\n        }\n\n        .attachments {\n            .preview {\n                width: 100px;\n                margin: 0 16px 8px 0;\n                border-radius: 4px;\n            }\n\n            .link {\n                margin-bottom: 2px;\n            }\n\n            .size {\n                font-size: 11px;\n            }\n        }\n    }\n}\n\n.loading-shade {\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    background: rgba(0, 0, 0, 0.15);\n    z-index: 1000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
